<template>
    <div v-if="vsLoadingXS" class="loading-container">
        <Lottie :options="defaultOptions" :height="loadingDimension" :width="loadingDimension" />
    </div>
    <div v-else>
        <virtual-staging-xs v-if="($mq === 'sm' || $mq === 'md') && !vsLoadingXS" />
        <div v-else-if="!vsLoadingXS">
            <div class="virtual-staging-outer-container">
                <div class="virtual-staging-sidebar-container">
                    <Sidebar />
                </div>
                <div class="virtual-staging-content-container">
                    <Header
                        :title="selectedImageName"
                        subtitle="Select Style or Catalog for Your Photo and We Will Stage It."
                    />
                    <div class="virtual-staging-content-content">
                        <virtual-staging-xl />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VirtualStagingXl from '../modules/services/virtual-staging/pages/VirtualStagingXl.vue';
import VirtualStagingXs from '../modules/services/virtual-staging/pages/VirtualStagingXs.vue';
import Sidebar from '@/components/sidebar/CollapsedSidebarXl.vue';
import Header from '@/components/header/index.vue';
import { mapGetters, mapState } from 'vuex';
import Lottie from 'vue-lottie';
import animationData from '@/assets/new-loading.json';
export default {
    components: {
        VirtualStagingXs,
        VirtualStagingXl,
        Header,
        Sidebar,
        Lottie,
        // Loading,
    },
    data() {
        return {
            defaultOptions: { animationData },
        };
    },
    computed: {
        ...mapGetters(['orderMediaDetailsVS', 'vsLoadingXS']),
        selectedImageName() {
            return this.orderMediaDetailsVS.mediaName.length > 15
                ? `${this.orderMediaDetailsVS.mediaName.substring(0, 15)}...`
                : this.orderMediaDetailsVS.mediaName;
        },
        loadingDimension() {
            return this.$mq === 'lg' ? 150 : 75;
        },
    },
    async created() {
        try {
            const imageId = this.$route.params.id.split('=')[1];
            const orderId = this.$cookies.get('project-id');
            const dispatchData = {
                imageId,
                orderId,
            };
            this.$store.dispatch('getVSData', dispatchData).then(() => {
                this.$store.commit('imageEnhancementServiceStore/SET_SELECTED_IMAGE_LOADED', true);
            });
        } catch (error) {}
    },
    beforeDestroy() {
        this.$store.commit('resetVsSatateXS');
    },
};
</script>

<style lang="scss" scoped>
.virtual-staging {
    &-outer-container {
        width: 93vw;
        max-width: 1312px;
        display: grid;
        grid-template-columns: 96px calc(100% - 128px);
        column-gap: 32px;
        margin: 0 auto;
    }

    &-content {
        &-content {
            margin-top: 24px;
            position: relative;
        }
    }
}
.loading {
    &-container {
        @include centerByFlex;
        position: fixed;
        inset: 0;
        background-color: rgba($color: #f5f5f5, $alpha: 0.7);
        z-index: 1000;
        @media (max-width: 768px) {
            height: calc(100vh - 80px);
        }
    }
}
</style>
